module.exports = __webpack_public_path__ + "static/media/delivery.72237e69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bottomNavigation/delivery.svg
// module id = 2248
// module chunks = 0